<template>
    <!-- <div> -->
    <contratos
        :dataServicos="obterDataServicos()"
        rotaDetalhar="Gescon_Apoios_Contratos_Detalhar"
        rotaListagem="Gescon_Apoios_Contratos"
        :permiteDetalhar="$temAcessoView('GESCON-APOIO-CONT-00')"
    ></contratos>
    <!-- </div> -->
</template>

<script>
import ContratosServicos from './ContratosServicos'
import Contratos from '../../contratos/Contratos2'

export default {
    methods: {
        obterDataServicos() {
            return ContratosServicos
        }
    },

    components: {
        Contratos
    }
}
</script>
